/* ==========================================================================
   HEALING FREQUENCY — comportamente de brand

   Acordul de renunțare la retragere pentru produse digitale:
   blochează finalizarea comenzii până e bifat și înregistrează
   confirmarea, cu dată și oră, ca atribut al comenzii.

   Folosește delegare de evenimente, ca să funcționeze și după ce
   sertarul de coș se re-randează prin AJAX.
   ========================================================================== */

(function () {
  'use strict';
  /* 22 oct. 2026 — varianta F: la „Finalizează comanda” nu se mai scrie nimic pe comandă.
     Acordul expres se dă la descărcare, pe pagina securizată (PAGINI SECURIZATE/). Blocul
     din 20 oct. care scria „Da, prin comandă, <data ora>” e în PAGINI SECURIZATE/arhiva-tema-live/. */
})();

/* ==========================================================================
   Fereastra de abonare pentru meditația ghidată.
   Apare o singură dată, după 20 de secunde. Închisă manual, tace 14 zile.
   După abonare, nu mai apare niciodată.
   ========================================================================== */

(function () {
  'use strict';

  var CHEIE = 'hf_pop_stare';
  var INTARZIERE = 20000;
  var TACERE_ZILE = 14;

  function stare() {
    try {
      return JSON.parse(localStorage.getItem(CHEIE)) || {};
    } catch (e) {
      return {};
    }
  }

  function scrie(obj) {
    try {
      localStorage.setItem(CHEIE, JSON.stringify(obj));
    } catch (e) {}
  }

  function trebuieAratat() {
    var s = stare();
    if (s.abonat) return false;
    if (s.inchisLa && Date.now() - s.inchisLa < TACERE_ZILE * 86400000) return false;
    /* Nu deranjăm pe cineva aflat în mijlocul cumpărării */
    if (/\/(cart|checkout|account)/.test(window.location.pathname)) return false;
    return true;
  }

  document.addEventListener('DOMContentLoaded', function () {
    var pop = document.querySelector('[data-hf-pop]');
    if (!pop) return;

    var intrebare = pop.querySelector('[data-hf-pop-intrebare]');
    var gata = pop.querySelector('[data-hf-pop-gata]');
    var form = pop.querySelector('[data-hf-pop-form]');
    var camp = pop.querySelector('input[type="email"]');
    var buton = pop.querySelector('[data-hf-pop-buton]');
    var eroare = pop.querySelector('[data-hf-pop-err]');

    var TEXT_BUTON = buton ? buton.textContent.trim() : 'Trimite';

    /* Butoanele de închidere se leagă ÎNAINTE de orice `return` de mai jos.
       Altfel, pe drumul de întoarcere după trimitere ieșeam din funcție
       înainte să apucăm să le legăm — și fereastra de mulțumire rămânea
       blocată pe ecran, fără X și fără Escape. S-a întâmplat de două ori. */
    pop.addEventListener('click', function (e) {
      if (e.target.closest('[data-hf-pop-close]')) inchide();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !pop.hidden) inchide();
    });

    /* Întoarcerea după trimitere. Shopify reîncarcă pagina cu
       `customer_posted=true` în adresă — ăsta e singurul semn de încredere
       că abonarea a fost înregistrată. Deschidem direct confirmarea. */
    if (window.location.search.indexOf('customer_posted=true') > -1) {
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
      if (window.history && history.replaceState) {
        history.replaceState({}, '', window.location.pathname);
      }
      window.scrollTo(0, 0);
      window.addEventListener('load', function () { window.scrollTo(0, 0); });
      reuseste();
      deschide();
      return;
    }

    if (!trebuieAratat()) return;
    setTimeout(deschide, INTARZIERE);

    function deschide() {
      pop.hidden = false;
      requestAnimationFrame(function () {
        pop.classList.add('is-open');
      });
      if (camp) setTimeout(function () { camp.focus(); }, 420);
    }

    function inchide() {
      pop.classList.remove('is-open');
      setTimeout(function () { pop.hidden = true; }, 400);
      var s = stare();
      s.inchisLa = Date.now();
      scrie(s);
    }

    function arataEroare(text) {
      if (!eroare) return;
      eroare.textContent = text;
      eroare.hidden = false;
    }

    function reuseste() {
      /* Marcăm abonarea înainte de a schimba ecranul: dacă omul închide
         fila exact acum, tot nu-i mai cerem adresa a doua oară. */
      var s = stare();
      s.abonat = true;
      scrie(s);

      if (intrebare) intrebare.hidden = true;
      if (eroare) eroare.hidden = true;
      if (gata) gata.hidden = false;
    }

    /* Trimiterea rămâne clasică, cu reîncărcare — și trebuie să rămână.

       Protecția anti-robot a Shopify atașează un jeton doar la o trimitere
       normală de formular. Orice variantă prin `fetch` primește
       `400 Missing CAPTCHA token`, iar jetonul nu se poate fabrica.

       Aici nu oprim nimic: verificăm adresa, tăiem ancora din `action` ca
       să nu sară pagina, și lăsăm browserul să-și facă treaba. */
    if (form) {
      form.addEventListener('submit', function (e) {
        var adresa = camp ? (camp.value || '').trim() : '';
        if (adresa.length < 5 || adresa.indexOf('@') < 1 || adresa.indexOf('.') < 0) {
          e.preventDefault();
          arataEroare('Scrie o adresă de e-mail validă.');
          if (camp) camp.focus();
          return;
        }

        if (eroare) eroare.hidden = true;
        if (buton) buton.textContent = 'Se trimite…';

        /* Shopify scrie în `action` o ancoră către id-ul formularului.
           Fereastra e ultimul lucru din pagină, așa că fără tăierea asta
           browserul ar sări până jos de tot după reîncărcare. */
        var a = form.getAttribute('action') || '';
        if (a.indexOf('#') > -1) form.setAttribute('action', a.split('#')[0]);
      });
    }
  });
})();

/* ==========================================================================
   Traducerea etichetelor venite de la Shopify, nu din temă.
   Filtrele și opțiunile de sortare sunt generate de platformă în limba
   principală a magazinului (engleză) și nu pot fi schimbate din fișierele
   de limbă ale temei. Le înlocuim la afișare.
   ========================================================================== */

(function () {
  'use strict';

  var DICTIONAR = {
    'Availability': 'Disponibilitate',
    'Price': 'Preț',
    'In stock': 'În stoc',
    'Out of stock': 'Stoc epuizat',
    'Featured': 'Recomandate',
    'Best selling': 'Cele mai vândute',
    'Alphabetically, A-Z': 'Alfabetic, A-Z',
    'Alphabetically, Z-A': 'Alfabetic, Z-A',
    'Price, low to high': 'Preț crescător',
    'Price, high to low': 'Preț descrescător',
    'Date, old to new': 'Cele mai vechi',
    'Date, new to old': 'Cele mai noi',
    'Most relevant': 'Cele mai relevante',
    'Relevance': 'Relevanță',
    'From': 'De la',
    'To': 'Până la',
    'Share': 'Distribuie',
    'Powered by Shopify': '',
    'Privacy policy': 'Politica de confidențialitate',
    'Refund policy': 'Politica de retur',
    'Terms of service': 'Termeni și condiții',
    'Shipping policy': 'Politica de livrare',
    'Contact information': 'Date de contact',
    'Cookie preferences': 'Preferințe cookie',
    'Legal notice': 'Mențiuni legale',
    'Subscribe': 'Abonează-te',
    'Search': 'Caută',
    'Quantity': 'Cantitate',
    'Sold out': 'Stoc epuizat',
    'Sale': 'Reducere'
  };

  function tradu(radacina) {
    var camp = document.createTreeWalker(radacina, NodeFilter.SHOW_TEXT);
    var noduri = [];
    while (camp.nextNode()) noduri.push(camp.currentNode);

    noduri.forEach(function (n) {
      var t = n.nodeValue.trim();
      if (DICTIONAR[t]) n.nodeValue = n.nodeValue.replace(t, DICTIONAR[t]);
    });

    radacina.querySelectorAll('option').forEach(function (o) {
      var t = o.textContent.trim();
      if (DICTIONAR[t]) o.textContent = DICTIONAR[t];
    });

    radacina.querySelectorAll('[placeholder]').forEach(function (e) {
      var t = e.getAttribute('placeholder').trim();
      if (DICTIONAR[t]) e.setAttribute('placeholder', DICTIONAR[t]);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    tradu(document.body);

    /* Filtrele se re-randează prin AJAX la fiecare selecție */
    var obs = new MutationObserver(function (mutatii) {
      mutatii.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType === 1) tradu(n);
        });
      });
    });

    var zona = document.querySelector('#main-collection-filters, .facets-container, #ProductGridContainer');
    if (zona) obs.observe(zona, { childList: true, subtree: true });
  });
})();

/* ==========================================================================
   Tragerea cu degetul sau cu mouse-ul peste caruselul de mărturii.
   Animația continuă singură; atingerea o oprește și lasă utilizatorul
   să deruleze manual, apoi repornește.
   ========================================================================== */

(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-hf-carusel]').forEach(function (zona) {
      var apasat = false;
      var start = 0;
      var scrollStart = 0;

      zona.style.overflowX = 'auto';
      zona.style.scrollbarWidth = 'none';

      function jos(x) {
        apasat = true;
        start = x;
        scrollStart = zona.scrollLeft;
        zona.classList.add('is-dragging');
      }

      function misca(x) {
        if (!apasat) return;
        zona.scrollLeft = scrollStart - (x - start);
      }

      function sus() {
        apasat = false;
        zona.classList.remove('is-dragging');
      }

      zona.addEventListener('mousedown', function (e) { jos(e.pageX); });
      zona.addEventListener('mousemove', function (e) {
        if (!apasat) return;
        e.preventDefault();
        misca(e.pageX);
      });
      zona.addEventListener('mouseup', sus);
      zona.addEventListener('mouseleave', sus);

      /* Pe telefon derularea nativă e mai bună decât orice imităm noi;
         doar oprim animația cât timp degetul e pe ecran. */
      zona.addEventListener('touchstart', function () { zona.classList.add('is-dragging'); }, { passive: true });
      zona.addEventListener('touchend', function () {
        setTimeout(function () { zona.classList.remove('is-dragging'); }, 2500);
      }, { passive: true });
    });
  });
})();

/* ==========================================================================
   Fotografiile celor trei plăci de pe prima pagină.
   Se inserează ca <img> deasupra textului, în ordinea blocurilor.
   ========================================================================== */

(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    if (!window.HF_PLACI) return;

    document.querySelectorAll('.multicolumn-list__item').forEach(function (item, i) {
      var sursa = window.HF_PLACI[i];
      if (!sursa) return;

      var card = item.querySelector('.multicolumn-card');
      if (!card || card.querySelector('.hf-tile-img')) return;

      var rama = document.createElement('div');
      rama.className = 'hf-tile-img';

      var img = document.createElement('img');
      img.src = sursa;
      img.alt = '';
      img.loading = 'lazy';
      rama.appendChild(img);

      card.insertBefore(rama, card.firstChild);
    });
  });
})();

/* ==========================================================================
   Butoanele „Afișați tot" de sub grile primesc text propriu, în funcție de
   secțiunea în care se află. Dawn folosește o singură traducere pentru toate.
   ========================================================================== */

(function () {
  'use strict';

  var ETICHETE = {
    frecvente: 'Descoperă frecvențele',
    instrumente: 'Descoperă instrumentele'
  };

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.shopify-section').forEach(function (sec) {
      var cheie = null;
      if (sec.id.indexOf('grila_frecvente') !== -1) cheie = 'frecvente';
      if (sec.id.indexOf('grila_instrumente') !== -1) cheie = 'instrumente';
      if (!cheie) return;

      sec.querySelectorAll('a.button, .center a').forEach(function (a) {
        var t = (a.innerText || '').trim();
        if (/afișa|afisa|view all/i.test(t)) a.textContent = ETICHETE[cheie];
      });
    });
  });
})();

/* ==========================================================================
   Tragerea cu mouse-ul peste galeriile din „Despre mine".
   Pe telefon derularea nativă funcționa deja; pe desktop nu exista niciun
   mod de a ajunge la fotografiile din dreapta.
   ========================================================================== */

(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.hf-galerie--carusel .hf-galerie__rand').forEach(function (rand) {
      var apasat = false, pornire = 0, scrollPornire = 0, miscat = 0;

      rand.addEventListener('mousedown', function (e) {
        apasat = true; miscat = 0;
        pornire = e.pageX;
        scrollPornire = rand.scrollLeft;
        rand.classList.add('is-dragging');
      });

      window.addEventListener('mousemove', function (e) {
        if (!apasat) return;
        e.preventDefault();
        var delta = e.pageX - pornire;
        miscat = Math.abs(delta);
        rand.scrollLeft = scrollPornire - delta;
      });

      window.addEventListener('mouseup', function () {
        if (!apasat) return;
        apasat = false;
        rand.classList.remove('is-dragging');
      });

      /* Rotița mouse-ului derulează orizontal peste galerie */
      rand.addEventListener('wheel', function (e) {
        if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
        var inainte = rand.scrollLeft;
        rand.scrollLeft += e.deltaY;
        if (rand.scrollLeft !== inainte) e.preventDefault();
      }, { passive: false });
    });
  });
})();

/* ==========================================================================
   Caruselul de mărturii — deplasare automată prin derulare reală.

   Banda nu se mai mișcă prin „transform", ci containerul chiar derulează.
   Consecința: tragerea cu degetul sau cu mouse-ul, rotița și tastele
   funcționează firesc, în ambele sensuri.

   Bucla e continuă pentru că lista de capturi e dublată în HTML: când
   derularea trece de jumătate, o readucem la început fără salt vizibil.
   ========================================================================== */

(function () {
  'use strict';

  var VITEZA = 0.45; /* pixeli pe cadru */

  document.addEventListener('DOMContentLoaded', function () {
    var lent = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('[data-hf-carusel]').forEach(function (zona) {
      var oprit = false, apasat = false, pornireX = 0, pornireScroll = 0, reluare = null;

      function jumatate() {
        return zona.scrollWidth / 2;
      }

      function pas() {
        if (!oprit && !apasat && !lent) {
          zona.scrollLeft += VITEZA;
          if (zona.scrollLeft >= jumatate()) zona.scrollLeft -= jumatate();
        }
        requestAnimationFrame(pas);
      }
      requestAnimationFrame(pas);

      function amanaReluarea() {
        clearTimeout(reluare);
        oprit = true;
        reluare = setTimeout(function () { oprit = false; }, 2500);
      }

      zona.addEventListener('mouseenter', function () { oprit = true; });
      zona.addEventListener('mouseleave', function () { if (!apasat) oprit = false; });

      zona.addEventListener('mousedown', function (e) {
        apasat = true;
        pornireX = e.pageX;
        pornireScroll = zona.scrollLeft;
        zona.classList.add('is-dragging');
        e.preventDefault();
      });

      window.addEventListener('mousemove', function (e) {
        if (!apasat) return;
        var d = e.pageX - pornireX;
        zona.scrollLeft = pornireScroll - d;
        /* buclă și când se trage înapoi, dincolo de început */
        if (zona.scrollLeft <= 0) {
          zona.scrollLeft += jumatate();
          pornireScroll += jumatate();
        }
      });

      window.addEventListener('mouseup', function () {
        if (!apasat) return;
        apasat = false;
        zona.classList.remove('is-dragging');
        amanaReluarea();
      });

      zona.addEventListener('touchstart', function () { oprit = true; }, { passive: true });
      zona.addEventListener('touchend', amanaReluarea, { passive: true });

      zona.addEventListener('scroll', function () {
        if (zona.scrollLeft <= 0) zona.scrollLeft += jumatate();
      }, { passive: true });

      zona.addEventListener('wheel', function (e) {
        if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
        zona.scrollLeft += e.deltaY;
        amanaReluarea();
        e.preventDefault();
      }, { passive: false });
    });
  });
})();

/* ==========================================================================
   Recenziile de pe pagina de produs.
   Datele sunt cele existente pe site-ul actual, mutate ca atare.
   Media și distribuția pe stele se calculează din note, nu sunt fixe.
   ========================================================================== */

(function () {
  'use strict';

  function stele(n) {
    var plin = Math.round(n);
    return '★★★★★'.slice(0, plin) + '☆☆☆☆☆'.slice(0, 5 - plin);
  }

  document.addEventListener('DOMContentLoaded', function () {
    var zona = document.querySelector('[data-hf-recenzii]');
    if (!zona) return;

    fetch(zona.dataset.sursa)
      .then(function (r) { return r.json(); })
      .then(function (tot) {
        var lista = tot[zona.dataset.handle];
        if (!lista || !lista.length) return;

        var suma = lista.reduce(function (a, r) { return a + r.s; }, 0);
        var medie = suma / lista.length;

        zona.querySelector('[data-hf-medie]').textContent = medie.toFixed(1).replace('.', ',');
        zona.querySelector('[data-hf-stele]').textContent = stele(medie);
        zona.querySelector('[data-hf-numar]').textContent =
          lista.length === 1 ? '1 recenzie' : lista.length + ' recenzii';

        /* distribuția pe stele, de la 5 la 1 */
        var bare = zona.querySelector('[data-hf-bare]');
        for (var s = 5; s >= 1; s--) {
          var cate = lista.filter(function (r) { return r.s === s; }).length;
          var proc = Math.round((cate / lista.length) * 100);
          var li = document.createElement('li');
          li.className = 'hf-bara';
          li.innerHTML =
            '<span class="hf-bara__nota">' + s + ' ★</span>' +
            '<span class="hf-bara__sina"><span class="hf-bara__umplut" style="width:' + proc + '%"></span></span>' +
            '<span class="hf-bara__cate">' + cate + '</span>';
          bare.appendChild(li);
        }

        var ul = zona.querySelector('[data-hf-lista]');
        lista.forEach(function (r) {
          var li = document.createElement('li');
          li.className = 'hf-recenzie';
          li.innerHTML =
            '<div class="hf-recenzie__sus">' +
              '<span class="hf-recenzie__nume">' + r.n + '</span>' +
              '<span class="hf-recenzie__stele" aria-label="' + r.s + ' din 5 stele">' + stele(r.s) + '</span>' +
            '</div>' +
            '<p class="hf-recenzie__text">' + r.t + '</p>';
          ul.appendChild(li);
        });

        zona.hidden = false;
      })
      .catch(function () { /* fără recenzii, secțiunea rămâne ascunsă */ });
  });
})();

/* ==========================================================================
   Deschiderea ferestrei cu meditația dintr-un link oarecare

   Klaviyo poate deschide un formular la comandă, prin coada lui de pe site.
   Legăm asta de o adresă convenită: orice link către `#meditatia` deschide
   fereastra în loc să navigheze.

   Avantajul e că nu trebuie atinsă tema ca să adaugi puncte de intrare noi.
   Pui un element de meniu, un buton într-o pagină sau un link în subsol, îi
   dai adresa `#meditatia`, și funcționează. Fereastra rămâne un singur loc,
   întreținut de Klaviyo.

   `_klOnsite` e o coadă: dacă scriptul lor n-a apucat să se încarce, cererea
   așteaptă acolo și se execută când ajunge. Nu e nevoie de verificări.
   ========================================================================== */

(function () {
  'use strict';

  var FORMULAR = 'UL7CPr';

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var link = e.target.closest('a[href$="#meditatia"]');
    if (!link) return;

    e.preventDefault();
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', FORMULAR]);
  });
})();
